interface LosCondition {
    new: string
    used: string
}

export const getLosCondition = (condition: string): string | undefined => {
    const conditions: LosCondition = {
        new: 'N',
        used: 'U',
    }

    return condition in conditions
        ? conditions[condition as keyof LosCondition]
        : undefined
}
